// This file contains all API functions for centralized access
import { getOrDefault } from "./helpers";

// Environment configuration
const ENV = process.env.REACT_APP_BACKEND_ENV || 'development';
const API_URLS = {
    development: 'http://localhost:3000/',
    production: 'https://bondly-be.onrender.com/'
};
const URL = API_URLS[ENV];

export var TOKEN = localStorage.getItem("token");

const handleResponse = async (response) => {
    var data = null;
    try {
        data = await response.json();
    } catch (error) {
        throw new Error("Network response is not ok");
    }
    if (!response.ok) {
        const errorMessage = response.status + ": " + getOrDefault(data, "message", "Network response is not ok");
        throw new Error(errorMessage)
    }
    return data;
};

const apiCall = async (endpoint, options = {}) => {
    const defaultHeaders = {
        'Content-Type': 'application/json',
        ...(TOKEN && { 'Authorization': `Bearer ${TOKEN}` })
    };

    const config = {
        headers: { ...defaultHeaders, ...options.headers },
        method: options.method || 'GET',
        ...options
    };

    if (options.body) {
        config.body = JSON.stringify(options.body);
    }

    try {
        const response = await fetch(endpoint.startsWith('http') ? endpoint : `${URL}${endpoint}`, config);
        const data = await handleResponse(response);
        
        // Handle token updates for authentication responses
        if (data.token) {
            localStorage.setItem("token", data.token);
            TOKEN = data.token;
        }
        
        return data;
    } catch (error) {
        console.error(`API call failed for endpoint ${endpoint}:`, error);
        throw error;
    }
};

// API Endpoints
export const getGroupsForUser = () => apiCall('get_groups_for_user', {
    method: 'GET'
});

export const login = (email, password) => apiCall('login', {
    method: 'POST',
    body: { email, password }
});

export const signup = (name, email, password) => apiCall('signup', {
    method: 'POST',
    body: { name, email, password }
});

export const getValidPeriodsForGroup = (groupId) => 
    apiCall(`get_valid_periods_for_group/${groupId}`, {
        method: 'GET'
    });

export const viewAnswerSheet = (userId, groupId, refDate) => {
    const isoDate = new Date(refDate).toISOString().split('T')[0];
    return apiCall(`view_answer_sheet/${userId}/${groupId}/${isoDate}`, {
        method: 'GET'
    });
};

export const getAnswerSheetForCurrentUser = (groupId, refDate) => {
    const isoDate = new Date(refDate).toISOString().split('T')[0];
    return apiCall(`get_answer_sheet/${groupId}/${isoDate}`, {
        method: 'GET'
    });
};

export const setAnswers = async (groupId, refDate, answers, imageLinks) => {
    const response = await apiCall('set_answers', {
        method: 'POST',
        body: { groupId, refDate, answers, imageLinks }
    });
    return response;
};

export const getCloudinarySignedUrls = () => apiCall('get_cloudinary_signed_urls', {
    method: 'GET'
});

export const getGroupsForAdminDashboard = () => apiCall('admin/groupDashboard', {
    method: 'GET'
});

export const getUserInfo = () => apiCall('get_user_info', {
    method: 'GET'
});

export const fetchImage = (url) => apiCall(`fetch_image?url=${url}`, {
    method: 'GET'
});

export const createGroup = (name) => apiCall("create_group", {
    method: 'POST',
    body: { name }
});

export const deleteGroup = (groupId) => apiCall("/admin/deleteGroup", {
    method: 'POST',
    body: { groupId }
});

export const addUserToGroup = (group_id, user_email) => apiCall("add_user_to_group", {
    method: 'POST',
    body: { group_id, user_email }
});


export const confirmToken = (emailToken) => apiCall("confirm_token", {
    method: 'POST',
    body: { emailToken }
});

export const sendVerificationEmail = () => apiCall("send_verification_email", {method: 'POST'})

export const uploadImageUsingFile = async (selectedFile) => {
    const formData = new FormData();
    formData.append("file", selectedFile);

    try {
        const response = await fetch(`${URL}upload_image`, {
            method: 'POST',
            body: formData,
            headers: {
                // 'Content-Type': 'multipart/form-data' is not needed with FormData
            },
        });

        if (!response.ok) {
            throw new Error("Image upload failed: " + response.statusText);
        }

        return await response.json(); // Assuming you want to return the response data
    } catch (error) {
        console.error("Image upload failed:", error);
        throw error;
    }
}; 

export const uploadImageUsingUrl = (image_url) => apiCall("upload_image", {
    method: 'POST',
    body: { image_url }
});

export const setUserSettings = (name, profilePhotoUrl) => apiCall("set_user_settings", {
    method: 'POST',
    body: { name, profilePhotoUrl }
});

export const getGroupAnswers = (groupId, refDate) => {
    const isoDate = new Date(refDate).toISOString().split('T')[0];
    return apiCall(`get_group_answers/${groupId}/${isoDate}`, {
        method: 'GET'
    });
};